(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fs-formula-table"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fs-formula-table')) {
  customElements.define('fs-formula-table', class extends HTMLElement {
    connectedCallback() {
      this.bindUpdates = () => this.subscribeUpdates();
      document.addEventListener('DOMContentLoaded', this.bindUpdates, {once: true});
      window.addEventListener('load', this.bindUpdates, {once: true});
      this.subscribeUpdates();
    }
    subscribeUpdates() {
      if (!this.isConnected || this.unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        if (String(data.sectionId) !== this.dataset.sectionId) return;
        const source = data.html.getElementById(this.id);
        if (source) this.innerHTML = source.innerHTML;
      });
    }
    disconnectedCallback() { document.removeEventListener('DOMContentLoaded', this.bindUpdates); window.removeEventListener('load', this.bindUpdates); this.unsubscribe?.(); this.unsubscribe = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fs-oil-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fs-oil-guide')) {
  customElements.define('fs-oil-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('[data-finder]');
      const result = this.querySelector('[data-result]');
      const content = this.querySelector('[data-result-content]');
      if (!form || !result || !content) return;
      const syncFields = () => {
        const priority = form.elements.priority.value;
        form.querySelectorAll('[data-followup]').forEach(group => {
          const active = group.dataset.followup === priority;
          group.hidden = !active;
          const select = group.querySelector('select');
          select.disabled = !active;
          select.required = active;
        });
      };
      syncFields();
      form.hidden = false;
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const values = new FormData(form);
        const priority = values.get('priority');
        const thc = values.get('thc');
        let key;
        if (priority === 'first') key = `first-${thc}`;
        if (priority === 'known') key = `classic-${values.get('strength')}-${thc}`;
        if (priority === 'explore') {
          const blend = values.get('blend');
          key = thc === 'free' && ['st_moritz', 'zermatt'].includes(blend) ? 'no_match' : blend;
        }
        const template = Array.from(this.querySelectorAll('[data-result-template]')).find(item => item.dataset.resultTemplate === key);
        if (!template) return;
        content.replaceChildren(template.content.cloneNode(true));
        result.hidden = false;
        result.focus({ preventScroll: true });
        result.scrollIntoView({ behavior: 'instant', block: 'nearest' });
      });
      form.addEventListener('change', () => {
        syncFields();
        result.hidden = true;
        content.replaceChildren();
      });
      form.addEventListener('reset', () => {
        result.hidden = true;
        content.replaceChildren();
        requestAnimationFrame(syncFields);
        form.elements.priority.focus();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fs-pet-mobile-buy"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const bar = document.querySelector('.fs-pet-mobile-buy');
      if (!bar || bar.dataset.ready) return;
      const buy = document.querySelector('main .product-form__submit, main .fs-category-card--animal button[name="add"]');
      if (!buy) return;
      bar.dataset.ready = 'true';
      const target = buy.closest('.product-form__buttons, form') || buy;
      if (!target.getAttribute('id')) target.setAttribute('id', 'PetBuyingOptions');
      const targetId = target.getAttribute('id');
      target.classList.add('fs-pet-buy-target');
      const link = bar.querySelector('a');
      link.href = '#' + targetId;
      const mobile = matchMedia('(max-width: 749px)');
      const footer = document.querySelector('footer.fs-home-footer') || [...document.querySelectorAll('footer')].at(-1);
      const update = () => {
        const blocked = document.querySelector('dialog[open], [aria-modal="true"][open], cart-drawer.active, .menu-drawer-container[open]') || document.body.classList.contains('overflow-hidden');
        bar.hidden = !mobile.matches || buy.getBoundingClientRect().bottom >= 0 || (footer && footer.getBoundingClientRect().top < innerHeight) || !!blocked;
      };
      link.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        history.replaceState(null, '', '#' + targetId);
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
        buy.focus({ preventScroll: true });
        bar.hidden = true;
      });
      new IntersectionObserver(update).observe(buy);
      if (footer) new IntersectionObserver(update).observe(footer);
      new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      mobile.addEventListener('change', update);
      let queued = false;
      window.addEventListener('scroll', () => {
        if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; update(); }); }
      }, { passive: true });
      update();
    };
    document.addEventListener('shopify:section:load', init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fs-pet-research-nav"] && !Shopify.designMode) return;
  try {
    (() => {
    const openHash = () => {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
      const target = document.getElementById(id);
      const topic = target?.closest('.fs-pet-topic');
      if (!topic) return;
      topic.open = true;
      requestAnimationFrame(() => { if (location.hash.slice(1) === id) target.scrollIntoView({ block: 'start', behavior: 'instant' }); });
    };
    const init = () => {
      document.querySelectorAll('[data-pet-research]').forEach(library => {
        if (library.dataset.navigationReady) return;
        library.dataset.navigationReady = 'true';
        const topics = [...library.querySelectorAll('.fs-pet-topic')];
        const button = library.querySelector('[data-expand-topics]');
        if (!button || !topics.length) return;
        button.hidden = false;
        const sync = () => { button.textContent = topics.every(topic => topic.open) ? button.dataset.collapseLabel : button.dataset.expandLabel; };
        button.addEventListener('click', () => {
          const expand = !topics.every(topic => topic.open);
          topics.forEach(topic => { topic.open = expand; });
          sync();
        });
        topics.forEach(topic => topic.addEventListener('toggle', sync));
        library.querySelectorAll('.fs-pet-research-nav a').forEach(link => link.addEventListener('click', event => {
          event.preventDefault();
          const topic = document.getElementById(link.hash.slice(1));
          if (topic) {
            topic.open = true;
            history.pushState(null, '', link.hash);
            topic.scrollIntoView({ block: 'start', behavior: 'instant' });
            topic.querySelector('summary').focus({ preventScroll: true });
          }
        }));
      });
      openHash();
    };
    window.addEventListener('hashchange', openHash);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fs-store-picker')) {
    customElements.define('fs-store-picker', class extends HTMLElement {
      static cookie(name) {
        return document.cookie.split('; ').find(value => value.startsWith(name + '='))?.slice(name.length + 1);
      }
      static remember(value) {
        document.cookie = `fs_store_choice=${encodeURIComponent(JSON.stringify(value))}; Domain=formulaswiss.com; Path=/; Max-Age=15552000; Secure; SameSite=Lax`;
      }
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.details = this.querySelector('.store-country-picker');
        this.trigger = this.querySelector('summary');
        this.status = this.querySelector('.store-country-picker__status');
        this.links = [...this.querySelectorAll('a[data-country]')];
        this.panel = this.querySelector('.store-country-picker__panel');
        this.back = this.querySelector('.store-country-picker__back');
        this.search = this.querySelector('input[type="search"]');
        this.empty = this.querySelector('.store-country-picker__empty');
        this.rows = [...this.querySelectorAll('[data-store-country]')];
        this.querySelector('.store-country-picker__search').hidden = false;
        this.search.addEventListener('input', () => this.filterCountries(), options);
        this.details.addEventListener('toggle', () => {
          this.setDrawerView(this.details.open);
          if (this.details.open) this.sizePanel();
          else { this.search.value = ''; this.filterCountries(); }
        }, options);
        window.addEventListener('resize', () => this.sizePanel(), options);
        if (this.dataset.position === 'footer') window.addEventListener('scroll', () => this.sizePanel(), { ...options, passive: true });
        window.visualViewport?.addEventListener('resize', () => this.sizePanel(), options);
        window.visualViewport?.addEventListener('scroll', () => this.sizePanel(), options);
        window.addEventListener('pageshow', event => {
          if (!event.persisted) return;
          this.operation = (this.operation || 0) + 1;
          this.automatic = false;
          this.busy = false;
          this.removeAttribute('aria-busy');
          if (this.originalName) this.querySelector('.store-country-picker__name').textContent = this.originalName;
          this.details.open = false;
          this.setDrawerView(false);
        }, options);
        this.restoreBasket();
        document.addEventListener('pointerdown', () => this.cancelAutomatic(), { ...options, once: true });
        document.addEventListener('keydown', () => this.cancelAutomatic(), { ...options, once: true });
        this.addEventListener('pointerdown', () => { this.keyboardNavigation = false; this.cancelAutomatic(); }, options);
        this.addEventListener('click', event => {
          if (event.target.closest('summary, .store-country-picker__back')) event.stopPropagation();
          if (event.target.closest('.store-country-picker__back')) {
            this.details.open = false;
            this.setDrawerView(false);
            this.trigger.focus({ preventScroll: true });
            return;
          }
          const link = event.target.closest('a[data-country]');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.switchTo(link);
        }, { ...options, capture: true });
        this.addEventListener('keydown', event => {
          this.cancelAutomatic();
          this.keyboardNavigation = event.key === 'Tab';
          if (event.key === 'Tab' && this.hasAttribute('data-drawer-view')) {
            const controls = [...this.panel.querySelectorAll('button, input, summary, a[href]')].filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
            const first = controls[0], last = controls[controls.length - 1];
            if ((event.shiftKey && event.target === first) || (!event.shiftKey && event.target === last)) {
              event.preventDefault();
              event.stopPropagation();
              (event.shiftKey ? last : first)?.focus();
              return;
            }
          }
          if (event.key !== 'Escape' || !this.details.open) return;
          event.preventDefault();
          event.stopPropagation();
          if (event.target === this.search && this.search.value) {
            this.search.value = '';
            this.filterCountries();
            return;
          }
          const languages = event.target.closest('.store-country-picker__languages[open]');
          const details = languages || this.details;
          details.open = false;
          if (details === this.details) this.setDrawerView(false);
          details.querySelector('summary').focus({ preventScroll: true });
        }, options);
        this.addEventListener('keyup', event => {
          if (event.key === 'Escape') event.stopPropagation();
        }, { ...options, capture: true });
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) this.details.open = false;
        }, options);
        this.addEventListener('focusout', event => {
          if (this.keyboardNavigation && event.relatedTarget && !this.contains(event.relatedTarget)) this.details.open = false;
        }, options);
        if (this.dataset.position === 'header' && !window.Shopify?.designMode) this.redirectToCountry();
      }
      cancelAutomatic() {
        this.constructor.interacted = true;
        document.querySelectorAll('fs-store-picker').forEach(picker => {
          if (!picker.automatic) return;
          picker.operation++;
          picker.automatic = false;
          picker.busy = false;
          picker.removeAttribute('aria-busy');
          picker.querySelector('.store-country-picker__name').textContent = picker.originalName;
        });
      }
      setDrawerView(open) {
        if (this.dataset.position !== 'drawer') return;
        const drawer = this.closest('.menu-drawer');
        const scroller = this.closest('.menu-drawer__navigation-container');
        if (!drawer || !scroller || open === this.hasAttribute('data-drawer-view')) return;
        if (open) {
          this.drawerScroll = scroller.scrollTop;
          scroller.scrollTop = 0;
          this.setAttribute('data-drawer-view', '');
          drawer.setAttribute('data-store-picker-open', '');
          this.sizePanel();
          if (!this.panel.contains(document.activeElement)) this.back.focus({ preventScroll: true });
        } else {
          this.removeAttribute('data-drawer-view');
          drawer.removeAttribute('data-store-picker-open');
          this.style.removeProperty('--picker-drawer-height');
          scroller.scrollTop = this.drawerScroll || 0;
        }
      }
      sizePanel() {
        if (!this.details.open) return;
        const viewport = window.visualViewport;
        const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
        if (this.dataset.position === 'footer') {
          this.setAttribute('data-footer-positioned', '');
          const top = viewport?.offsetTop || 0;
          const button = this.trigger.getBoundingClientRect();
          const above = Math.max(0, Math.min(button.top - 8, bottom - 16) - top - 16);
          const below = Math.max(0, bottom - Math.max(button.bottom + 8, top + 16) - 16);
          const openAbove = above >= Math.min(260, (bottom - top) * .5) || above >= below;
          this.panel.style.setProperty('--picker-available-height', Math.max(80, Math.floor(openAbove ? above : below)) + 'px');
          const height = this.panel.getBoundingClientRect().height;
          const desiredTop = openAbove ? button.top - 8 - height : button.bottom + 8;
          const panelTop = Math.max(top + 8, Math.min(desiredTop, bottom - height - 8));
          this.panel.style.setProperty('--picker-footer-top', Math.floor(panelTop) + 'px');
          const left = viewport?.offsetLeft || 0;
          const right = left + (viewport?.width || window.innerWidth);
          const width = this.panel.getBoundingClientRect().width;
          const panelLeft = Math.max(left + 8, Math.min(button.left + button.width / 2 - width / 2, right - width - 8));
          this.panel.style.setProperty('--picker-footer-left', Math.floor(panelLeft) + 'px');
          return;
        }
        if (this.hasAttribute('data-drawer-view')) {
          const drawer = this.closest('.menu-drawer');
          const available = Math.max(0, Math.min(drawer.clientHeight, bottom - drawer.getBoundingClientRect().top));
          this.style.setProperty('--picker-drawer-height', Math.floor(available) + 'px');
          return;
        }
        let available = bottom - this.panel.getBoundingClientRect().top - 16;
        const minimum = Math.min(220, (viewport?.height || innerHeight) * .75);
        const scroller = this.closest('.menu-drawer__navigation-container');
        if (scroller && available < minimum) {
          scroller.scrollTop += minimum - available;
          available = bottom - this.panel.getBoundingClientRect().top - 16;
        }
        this.panel.style.setProperty('--picker-available-height', Math.max(80, Math.floor(available)) + 'px');
      }
      filterCountries() {
        const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
        const query = normalize(this.search.value);
        let names;
        try { names = ['en', this.dataset.currentLanguage].map(locale => new Intl.DisplayNames([locale], { type: 'region' })); } catch (_) {}
        let languages;
        try { languages = ['en', this.dataset.currentLanguage].map(locale => new Intl.DisplayNames([locale], { type: 'language' })); } catch (_) {}
        let visible = 0;
        for (const row of this.rows) {
          const code = row.dataset.storeCountry;
          const aliases = code === 'INT' ? 'International' : (code === 'GB' ? 'UK ' : '') + (names || []).map(display => display.of(code)).join(' ');
          const languageAliases = [...row.querySelectorAll('a[data-language]')].map(link => {
            const language = link.dataset.language;
            try { return [language, ...(languages || []).map(display => display.of(language)), new Intl.DisplayNames([language], { type: 'language' }).of(language)].join(' '); }
            catch (_) { return language; }
          }).join(' ');
          row.hidden = !normalize(row.textContent + ' ' + code + ' ' + aliases + ' ' + languageAliases).includes(query);
          if (!row.hidden) visible++;
        }
        this.empty.textContent = this.empty.dataset.message.replace('[search]', this.search.value.trim());
        this.empty.hidden = visible > 0;
        this.querySelector('.store-country-picker__menu').scrollTop = 0;
      }
      restoreBasket() {
        try {
          const raw = this.constructor.cookie('fs_cart_handoff');
          if (!raw) return;
          const handoff = JSON.parse(decodeURIComponent(raw));
          if (handoff.host !== location.hostname || handoff.expires < Date.now()) return;
          if (!this.links.some(link => link.dataset.store !== 'external' && new URL(link.href).hostname === handoff.host)) return;
          document.cookie = 'fs_cart_handoff=; Domain=formulaswiss.com; Path=/; Max-Age=0; Secure; SameSite=Lax';
          if (typeof handoff.cart !== 'string' || !/^[A-Za-z0-9_%?=&.~-]+$/.test(handoff.cart)) return;
          if (this.constructor.cookie('cart') === handoff.cart) return;
          document.cookie = `cart=${handoff.cart}; Path=/; Max-Age=1209600; Secure; SameSite=Lax`;
          if (this.constructor.cookie('cart') === handoff.cart) {
            this.constructor.restoring = true;
            location.reload();
          }
        } catch (_) {}
      }
      async switchTo(link, automatic = false) {
        if (this.busy || this.constructor.restoring) return;
        if (automatic && this.constructor.interacted) return;
        const operation = this.operation = (this.operation || 0) + 1;
        this.automatic = automatic;
        this.busy = true;
        this.setAttribute('aria-busy', 'true');
        this.status.hidden = true;
        const name = this.querySelector('.store-country-picker__name');
        const originalName = name.textContent;
        this.originalName = originalName;
        name.textContent = this.dataset.loading;
        try {
          const destination = new URL(link.href);
          if (link.dataset.store === 'external') {
            if (automatic) {
              const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { signal: AbortSignal.timeout(8000) });
              if (!response.ok) throw new Error('Cart unavailable');
              const cart = await response.json();
              if (operation !== this.operation) return;
              if (cart.item_count > 0) throw new Error('Keep the current basket');
            } else {
              this.constructor.remember({ country: link.dataset.country, language: link.dataset.language });
            }
            this.navigate(destination.href);
            return;
          }
          if (destination.origin !== location.origin) {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { signal: AbortSignal.timeout(8000) });
            if (!response.ok) throw new Error('Cart unavailable');
            const cart = await response.json();
            if (operation !== this.operation) return;
            if (cart.item_count > 0) {
              const value = this.constructor.cookie('cart');
              if (!value) throw new Error('Cart cookie unavailable');
              const handoff = encodeURIComponent(JSON.stringify({ host: destination.hostname, cart: value, expires: Date.now() + 120000 }));
              document.cookie = `fs_cart_handoff=${handoff}; Domain=formulaswiss.com; Path=/; Max-Age=120; Secure; SameSite=Lax`;
              if (this.constructor.cookie('fs_cart_handoff') !== handoff) throw new Error('Cart transfer unavailable');
            }
          }
          if (!automatic) this.constructor.remember({ country: link.dataset.country, language: link.dataset.language });
          const form = this.querySelector('form');
          const path = this.currentPath();
          const query = new URLSearchParams(location.search);
          ['country', 'language', 'locale', 'shpxid'].forEach(key => query.delete(key));
          if (automatic || (path === '/' && link.dataset.country !== 'INT')) query.set('country', link.dataset.country);
          const search = query.size ? '?' + query.toString() : '';
          form.action = destination.origin + '/localization';
          form.elements.country_code.disabled = link.dataset.country === 'INT';
          form.elements.country_code.value = link.dataset.country;
          form.elements.language_code.value = link.dataset.language;
          form.elements.return_to.value = path + search;
          if (automatic || (path === '/' && link.dataset.country !== 'INT')) {
            destination.pathname = destination.pathname.replace(/\/$/, '') + path;
            destination.search = search;
            this.navigate(destination.href);
            return;
          }
          if (link.dataset.country === 'INT') {
            destination.pathname = path;
            destination.search = search;
            this.navigate(destination.href);
            return;
          }
          form.submit();
        } catch (_) {
          if (operation !== this.operation) return;
          name.textContent = originalName;
          this.status.hidden = automatic;
          this.busy = false;
          this.automatic = false;
          this.removeAttribute('aria-busy');
        }
      }
      navigate(url) { location.assign(url); }
      currentPath() {
        const root = this.dataset.root.replace(/\/$/, '');
        if (root && location.pathname === root) return '/';
        return root && location.pathname.startsWith(root + '/') ? location.pathname.slice(root.length) : location.pathname;
      }
      async redirectToCountry() {
        const query = new URLSearchParams(location.search);
        if (this.constructor.restoring || this.constructor.interacted || this.dataset.currentCountry !== 'INT') return;
        if (location.hostname.replace(/^www\./, '') !== 'formulaswiss.com') return;
        if (/^\/(cart|checkout|checkouts|account|challenge|password|localization)(\/|$)/.test(this.currentPath())) return;
        if (['preview_theme_id', 'country', 'language', 'locale'].some(key => query.has(key))) return;
        if (this.constructor.cookie('fs_auto_redirect_attempt')) return;
        const redirect = link => {
          if (!this.isConnected || this.constructor.interacted) return;
          document.cookie = 'fs_auto_redirect_attempt=1; Domain=formulaswiss.com; Path=/; Max-Age=300; Secure; SameSite=Lax';
          if (this.constructor.cookie('fs_auto_redirect_attempt') !== '1') return;
          return this.switchTo(link, true);
        };
        let saved;
        const savedPreference = this.constructor.cookie('fs_store_choice');
        try { saved = JSON.parse(decodeURIComponent(savedPreference || '')); } catch (_) {}
        if (saved) {
          if (saved.country === 'INT') return;
          const link = this.links.find(item => item.dataset.country === saved.country && item.dataset.language === saved.language) || this.links.find(item => item.dataset.country === saved.country);
          if (link) {
            return redirect(link);
          }
        }
        try {
          const response = await fetch('/browsing_context_suggestions.json', { signal: AbortSignal.timeout(5000) });
          if (!response.ok) return;
          const data = await response.json();
          if (this.constructor.interacted || this.constructor.cookie('fs_store_choice') !== savedPreference) return;
          const country = data.detected_values?.country?.handle;
          const choices = this.links.filter(link => link.dataset.country === country);
          if (!choices.length || country === this.dataset.currentCountry) return;
          const defaultLanguage = choices[0].closest('[data-store-country]').dataset.defaultLanguage;
          let choice = choices.find(link => link.dataset.language === defaultLanguage) || choices[0];
          for (const language of navigator.languages || [navigator.language]) {
            const match = choices.find(link => link.dataset.language.toLowerCase() === language.toLowerCase() || link.dataset.language.split('-')[0] === language.split('-')[0]);
            if (match) { choice = match; break; }
          }
          return redirect(choice);
        } catch (_) {}
      }
      disconnectedCallback() { this.setDrawerView(false); this.events?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-details-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialise = () => {
      document.querySelectorAll('[data-fs-report-picker]').forEach(picker => {
        if (picker.dataset.ready) return;
        const section = document.getElementById(`MainProduct-${picker.dataset.sectionId}`);
        const source = section?.querySelector('[data-fs-purchase-data]');
        if (!source) return;
        const data = JSON.parse(source.textContent);
        const reports = JSON.parse(picker.querySelector('[data-fs-report-map]').textContent);
        const form = document.getElementById(data.formId);
        if (!form) return;
        const link = picker.querySelector('[data-fs-report-link]');
        const caption = picker.querySelector('[data-fs-report-selection]');
        const missing = picker.querySelector('[data-fs-report-missing]');
        const update = () => {
          const radios = [...section.querySelectorAll('variant-radios fieldset')];
          const selects = [...section.querySelectorAll('variant-selects select')];
          const options = radios.length ? radios.map(group => group.querySelector('input:checked')?.value) : selects.map(select => select.value);
          const variant = options.length ? data.variants.find(item => item.options.every((value, index) => value === options[index])) : data.variants.find(item => String(item.id) === form.elements.id?.value);
          const url = variant && reports[variant.id];
          const valid = typeof url === 'string' && url.startsWith('https://');
          if (valid) link.href = url;
          else link.removeAttribute('href');
          link.hidden = !valid;
          caption.hidden = !valid;
          missing.hidden = valid;
          const labels = [...section.querySelectorAll('[data-fs-purchase-options] input:checked + label .fs-choice-title')].map(el => el.textContent.trim());
          caption.textContent = labels.length ? labels.join(' · ') : (variant?.public_title || '').replaceAll('&lt;', '<');
          if (valid) link.setAttribute('aria-label', `${link.textContent.trim()}${caption.textContent ? `, ${caption.textContent}` : ''}`);
          picker.dataset.variant = variant ? String(variant.id) : '';
        };
        picker.dataset.ready = 'true';
        section.addEventListener('change', () => queueMicrotask(update));
        update();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once: true});
    else initialise();
    document.addEventListener('shopify:section:load', initialise);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-evidence"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const link = event.target.closest('[data-fs-evidence-group]');
    if (!link) return;
    const target = document.getElementById(`fs-product-${link.dataset.fsEvidenceGroup}`);
    const disclosure = target?.closest('details');
    if (!disclosure) return;
    event.preventDefault();
    disclosure.open = true;
    disclosure.querySelector('summary')?.focus({preventScroll: true});
    disclosure.scrollIntoView({block: 'start', behavior: 'instant'});
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-purchase-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialise = () => {
      document.querySelectorAll('[data-fs-purchase-bar]').forEach(bar => {
        if (bar.dataset.ready) return;
        const section = document.getElementById(`MainProduct-${bar.dataset.sectionId}`);
        const source = document.getElementById(`fs-purchase-data-${bar.dataset.sectionId}`);
        if (!section || !source) return;
        const data = JSON.parse(source.textContent);
        const form = document.getElementById(data.formId);
        const original = form?.querySelector('[name="add"]');
        if (!original) return;
        bar.dataset.ready = 'true';
        document.body.append(bar);
        const button = bar.querySelector('button');
        const selection = bar.querySelector('a');
        const mobile = matchMedia('(max-width: 749px)');
        let scheduled = false;
        let submitted = false;
        const update = () => {
          scheduled = false;
          if (!section.isConnected) { cleanup(); return; }
          const variant = data.variants.find(item => String(item.id) === form.elements.id?.value);
          button.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
          button.textContent = original.querySelector('span')?.textContent.trim() || original.textContent.trim();
          button.setAttribute('aria-busy', String(original.classList.contains('loading')));
          bar.querySelector('[data-fs-bar-price]').textContent = variant && !original.disabled ? data.prices[variant.id] : '';
          bar.querySelector('[data-fs-bar-each]').textContent = variant && !original.disabled ? data.eachLabel : '';
          const quantity = document.querySelector(`input[name="quantity"][form="${data.formId}"]`)?.value || form.elements.quantity?.value || '1';
          const choices = [...section.querySelectorAll('[data-fs-purchase-options] input:checked + label .fs-choice-title')].map(label => label.textContent.trim());
          bar.querySelector('[data-fs-bar-options]').textContent = `${quantity} × ${choices.length ? choices.join(' · ') : variant?.public_title || section.querySelector('h1')?.textContent.trim() || ''}`;
          // Show only after all visible purchase actions, including pack offers, have scrolled away.
          const actions = [original, ...section.querySelectorAll('.fs-volume-offer')].filter(el => el.getClientRects().length);
          const passed = actions.length && actions.every(el => el.getBoundingClientRect().bottom < 0);
          const editing = document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]), textarea, select');
          bar.hidden = !mobile.matches || !passed || !!editing;
          document.body.classList.toggle('fs-has-purchase-bar', mobile.matches);
          if (!bar.hidden) document.body.style.setProperty('--fs-purchase-bar-height', `${bar.offsetHeight}px`);
          const error = form.closest('product-form').querySelector('.product-form__error-message-wrapper');
          if (submitted && error && !error.hidden && error.textContent.trim()) {
            submitted = false;
            error.scrollIntoView({block: 'center', behavior: 'instant'});
          }
        };
        const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } };
        button.addEventListener('click', () => {
          if (original.disabled || original.getAttribute('aria-disabled') === 'true') return;
          submitted = true;
          original.click();
          update();
        });
        selection.addEventListener('click', event => {
          event.preventDefault();
          const target = section.querySelector('[data-fs-purchase-options] input:checked, variant-selects select, input[name="quantity"]') || original;
          target.scrollIntoView({block: 'center', behavior: 'instant'});
          target.focus({preventScroll: true});
        });
        const observer = new MutationObserver(schedule);
        observer.observe(form.closest('product-form'), {subtree: true, attributes: true, childList: true, characterData: true});
        section.addEventListener('change', schedule);
        section.addEventListener('input', schedule);
        window.addEventListener('scroll', schedule, {passive: true});
        window.addEventListener('resize', schedule);
        document.addEventListener('focusin', schedule);
        document.addEventListener('focusout', schedule);
        const cleanup = () => {
          observer.disconnect();
          window.removeEventListener('scroll', schedule);
          window.removeEventListener('resize', schedule);
          document.removeEventListener('focusin', schedule);
          document.removeEventListener('focusout', schedule);
          section.removeEventListener('change', schedule);
          section.removeEventListener('input', schedule);
          bar.remove();
          document.body.classList.remove('fs-has-purchase-bar');
        };
        document.addEventListener('shopify:section:unload', event => { if (event.detail.sectionId === data.sectionId) cleanup(); });
        update();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once: true});
    else initialise();
    document.addEventListener('shopify:section:load', initialise);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-purchase-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialise = (root) => {
      root.querySelectorAll('[data-fs-purchase-options]').forEach((picker) => {
        if (picker.dataset.fsReady) return;
        const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
        const groups = [...picker.querySelectorAll('fieldset')];
        const update = () => {
          const selected = groups.map(group => group.querySelector('input:checked')?.value);
          groups.forEach((group, index) => {
            group.querySelectorAll('input[type="radio"]').forEach((input) => {
              const available = variants.some(variant => variant.available && variant.options.every((value, position) => value === (position === index ? input.value : selected[position])));
              input.classList.toggle('disabled', !available);
              const status = document.getElementById(input.getAttribute('aria-describedby'));
              if (status) status.hidden = available;
            });
          });
        };
        picker.dataset.fsReady = 'true';
        picker.addEventListener('change', () => queueMicrotask(update));
        update();
      });
    };
    const start = () => customElements.whenDefined('variant-radios').then(() => initialise(document));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
    else start();
    document.addEventListener('shopify:section:load', event => initialise(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-refinement-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const cleanups = new WeakMap();
    const initialise = root => {
      root.querySelectorAll('[data-fs-gallery-config]').forEach(source => {
        if (cleanups.has(source) || typeof subscribe !== 'function') return;
        const config = JSON.parse(source.textContent);
        const unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          const data = event.data;
          if (data.sectionId !== config.sectionId || data.variant.featured_media) return;
          const value = data.variant.options[config.optionPosition];
          if (!value) return;
          const broad = value.includes('0.0%') || value.includes('0,0%');
          const mediaId = broad ? config.broadMediaId : config.fullMediaId;
          document.querySelectorAll(`[id^="MediaGallery-${config.sectionId}"]`).forEach(gallery => {
            if (gallery.querySelector(`[data-media-id="${config.sectionId}-${mediaId}"]`)) gallery.setActiveMedia?.(`${config.sectionId}-${mediaId}`, true);
          });
          const modal = document.querySelector(`#ProductModal-${config.sectionId} .product-media-modal__content`);
          const image = modal?.querySelector(`[data-media-id="${mediaId}"]`);
          if (image) modal.prepend(image);
        });
        cleanups.set(source, unsubscribe);
        source.dataset.ready = 'true';
      });
    };
    if (document.readyState !== 'complete') {
      document.addEventListener('DOMContentLoaded', () => initialise(document), {once: true});
      window.addEventListener('load', () => initialise(document), {once: true});
    }
    initialise(document);
    document.addEventListener('shopify:section:load', event => initialise(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('[data-fs-gallery-config]').forEach(source => {
        cleanups.get(source)?.();
        cleanups.delete(source);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["purchase-button-states"] && !Shopify.designMode) return;
  try {
    (() => {
    const cleanups = new WeakMap();
    const initialise = (root) => {
      root.querySelectorAll('[data-fs-checkout-state]').forEach(state => {
        if (cleanups.has(state)) return;
        const form = state.closest('form');
        const primary = form?.querySelector('[name="add"]');
        if (!primary) return;
        const section = state.closest('.fs-product-purchase') || form;
        const source = section.querySelector('[data-fs-purchase-data]');
        const variants = source ? JSON.parse(source.textContent).variants : null;
        const update = () => {
          const selected = variants?.find(variant => String(variant.id) === form.elements.id?.value);
          const disabled = primary.disabled || primary.getAttribute('aria-disabled') === 'true' || selected?.available === false;
          if (state.disabled !== disabled) state.disabled = disabled;
          const busy = String(primary.classList.contains('loading'));
          if (state.getAttribute('aria-busy') !== busy) state.setAttribute('aria-busy', busy);
        };
        const observer = new MutationObserver(update);
        observer.observe(primary, {attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class']});
        section.addEventListener('change', update);
        cleanups.set(state, () => {
          observer.disconnect();
          section.removeEventListener('change', update);
          cleanups.delete(state);
        });
        state.dataset.ready = 'true';
        update();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), {once: true});
    else initialise(document);
    document.addEventListener('shopify:section:load', event => initialise(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('[data-fs-checkout-state]').forEach(state => cleanups.get(state)?.());
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-discount-presentation"] && !Shopify.designMode) return;
  try {
    (() => {
    const copySource = document.getElementById('fs-savings-copy');
    const copy = copySource ? JSON.parse(copySource.textContent) : null;
    let nextId = 0;
    let scheduled = false;
    let purchaseData;
    let observedSubmit;
    const setText = (element, text) => { if (element.textContent !== text) element.textContent = text; };
    const priceOffer = (offer, data, bundles) => {
      const form = document.getElementById(data.formId);
      const original = form?.querySelector('[name="add"]');
      const button = offer.querySelector('.fs-volume-button');
      if (!original) return;
      button.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
      let price = offer.querySelector('.fs-volume-price');
      if (!price) {
        price = document.createElement('span');
        price.className = 'fs-volume-price';
        price.id = `${button.getAttribute('aria-labelledby').split(' ')[0]}-price`;
        price.append(document.createElement('strong'), document.createElement('small'), document.createElement('em'));
        offer.querySelector('.fs-volume-action').before(price);
      }
      price.hidden = true;
      delete offer.dataset.fsDiscountPercent;
      const description = offer.querySelector('.bndlr-volume-main-text');
      const savings = offer.querySelector('.bndlr-volume-saving-text');
      if (!offer.dataset.fsOriginalDescription) offer.dataset.fsOriginalDescription = description.textContent;
      if (!offer.dataset.fsOriginalSavings) offer.dataset.fsOriginalSavings = savings.textContent;
      setText(description, offer.dataset.fsOriginalDescription);
      setText(savings, offer.dataset.fsOriginalSavings);
      offer.classList.remove('fs-volume-quoted');
      button.removeAttribute('aria-describedby');
      const widget = offer.closest('.bundler-volume-target-element');
      if (!widget || String(data.productId) !== widget.dataset.productId) return;
      const bundle = bundles.find(item => String(item.id) === widget.dataset.bundle);
      const tier = bundle?.volume_discounts?.[Number(offer.dataset.discountIndex)];
      const variant = data.variants.find(item => String(item.id) === form.elements.id?.value);
      const quantity = Number(offer.dataset.quantity);
      const enteredQuantity = Number(document.querySelector(`input[name="quantity"][form="${data.formId}"]`)?.value || form.elements.quantity?.value || 1);
      // The app adds at least the entered quantity. Suppress a pack quote when that differs.
      if (!variant?.available || button.disabled || enteredQuantity > quantity || !Number.isSafeInteger(quantity) || quantity < 1) return;
      if (!tier || bundle.is_quantity_break === 'true' || form.elements.selling_plan?.value || variant.requires_selling_plan) return;
      if (window.Shopify?.currency?.active !== data.currency || typeof window.bndlr?.updateCartWithDiscounts !== 'function') return;
      try {
        const line = variant.price * quantity;
        // Bundler's public calculator returns a simulation; it does not change the cart.
        const result = window.bndlr.updateCartWithDiscounts({
          items: [{id: variant.id, variant_id: variant.id, product_id: data.productId, key: String(variant.id), quantity,
            price: variant.price, original_price: variant.price, final_price: variant.price,
            line_price: line, original_line_price: line, final_line_price: line, properties: {}, discounts: []}],
          item_count: quantity, original_total_price: line, total_price: line, total_discount: 0, currency: data.currency
        });
        const applied = result.applicable_combos.flatMap(combo => Object.values(combo));
        const total = result.total_amount_discounted;
        if (!applied.length || applied.some(item => String(item.bundle_id) !== String(bundle.id) || String(item.volume_discount?.id) !== String(tier.id))) return;
        if (!Number.isFinite(total) || total < 0 || total >= line) return;
        const money = new Intl.NumberFormat(document.documentElement.lang || undefined, {style: 'currency', currency: data.currency, currencyDisplay: 'narrowSymbol'});
        setText(price.querySelector('strong'), `${money.format(total / quantity / 100)} ${data.eachLabel}`);
        const percent = Math.round((line - total) * 100 / line);
        setText(description, copy ? copy.headline.replace('[quantity]', String(quantity)).replace('[percent]', String(percent)) : data.packLabel.replace('[quantity]', String(quantity)));
        setText(savings, data.addPackLabel.replace('[quantity]', String(quantity)));
        setText(price.querySelector('small'), data.packTotalLabel.replace('[price]', money.format(total / 100)) + (copy ? ' · ' + copy.saving.replace('[amount]', money.format((line - total) / 100)) : ''));
        setText(price.querySelector('em'), copy ? '' : data.packSavingLabel.replace('[amount]', money.format((line - total) / 100)).replace('[percent]', String(percent)));
        offer.dataset.fsDiscountPercent = String(percent);
        offer.classList.add('fs-volume-quoted');
        button.setAttribute('aria-labelledby', savings.id);
        price.dataset.total = String(total);
        price.dataset.variant = String(variant.id);
        price.hidden = false;
        button.setAttribute('aria-describedby', price.id);
      } catch (_) {
        // Leave the app's original offer visible if its calculator is unavailable or changes.
      }
    };

    const enhance = () => {
      scheduled = false;
      const template = document.getElementById('fs-volume-action-template');
      if (!template) return;
      if (!purchaseData) {
        const source = document.querySelector('[data-fs-purchase-data]');
        if (source) purchaseData = JSON.parse(source.textContent);
      }
      let bundles = [];
      if (purchaseData) {
        try { bundles = window.bndlr?.getBundles?.() || []; } catch (_) { /* App may still be loading. */ }
        const original = document.getElementById(purchaseData.formId)?.querySelector('[name="add"]');
        if (original && observedSubmit !== original) {
          new MutationObserver(schedule).observe(original, {attributes: true, attributeFilter: ['disabled', 'aria-disabled']});
          observedSubmit = original;
        }
      }

      document.querySelectorAll('.bndlr-volume-style-0.bndlr-has-savings-text[data-quantity]').forEach((offer) => {
        const savings = offer.querySelector('.bndlr-volume-saving-text');
        const description = offer.querySelector('.bndlr-volume-main-text');
        if (!savings || !description) return;

        const id = `fs-volume-${++nextId}`;
        if (!description.id) description.id = `${id}-description`;
        if (!savings.id) savings.id = `${id}-savings`;

        let action = offer.querySelector('.fs-volume-action');
        if (!action) {
          action = template.content.firstElementChild.cloneNode(true);
          action.id = `${id}-action`;
          offer.append(action);
        }

        let button = offer.querySelector('.fs-volume-button');
        if (!button) {
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'fs-volume-button';
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            offer.querySelector('.bndlr-volume-saving-text')?.click();
          });
          offer.append(button);
        }

        button.setAttribute('aria-labelledby', `${description.id} ${savings.id} ${action.id}`);
        offer.classList.add('fs-volume-offer');
        if (purchaseData) priceOffer(offer, purchaseData, bundles);
      });
      if (copy) document.querySelectorAll('.bndlr-volume').forEach(widget => {
        const offers = [...widget.querySelectorAll('.fs-volume-offer')];
        const quoted = offers.filter(offer => Number(offer.dataset.fsDiscountPercent) > 0);
        const ranked = [...quoted].sort((a, b) => Number(b.dataset.fsDiscountPercent) - Number(a.dataset.fsDiscountPercent) || Number(a.dataset.quantity) - Number(b.dataset.quantity));
        const best = ranked.length > 1 && Number(ranked[0].dataset.fsDiscountPercent) > Number(ranked[ranked.length - 1].dataset.fsDiscountPercent) ? ranked[0] : null;
        offers.forEach(offer => {
          offer.classList.toggle('fs-offer-best', offer === best);
          let badge = offer.querySelector('.fs-offer-best-label');
          if (!badge && offer === best) {
            badge = document.createElement('span');
            badge.className = 'fs-offer-best-label';
            badge.textContent = copy.best;
            offer.prepend(badge);
          }
          if (badge) badge.hidden = offer !== best;
        });
        let note = widget.querySelector('.fs-offers-note');
        if (!note && quoted.length && copy.automatic) {
          note = document.createElement('p');
          note.className = 'fs-offers-note';
          note.textContent = copy.automatic;
          widget.append(note);
        }
        if (note) note.hidden = !quoted.length || !copy.automatic;
      });
    };

    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(enhance);
    };

    new MutationObserver((mutations) => {
      if (mutations.some((mutation) => [...mutation.addedNodes].some((node) =>
        node.nodeType === 1 && (node.matches('.bndlr-volume, .bndlr-volume *') || node.querySelector('.bndlr-volume'))
      ))) schedule();
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('change', event => {
      if (event.target.closest('.fs-product-purchase')) schedule();
    });
    document.addEventListener('input', event => {
      if (event.target.matches('input[name="quantity"]')) schedule();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
    else enhance();
  })();
  } catch(e) { console.error(e); }
})();

})();
